import { useEffect } from "react";
import { useState } from "react";
import useSWR from "swr";
import { LatestJournalResponseSchema } from "@/types/schemas";
import { fetcherTyped } from "@/lib/utils";
import { EventSourceMessageJournal } from "@/components/dashboard/createEventSource";
import { TaskType } from "@/types";

export const useLatestJournal = (
  run: boolean,
  taskId?: string,
  refreshInterval?: number,
  limit?: number
) => {
  const { data, mutate } = useSWR(
    run
      ? "/api/journal/latest?sortBy=id&sortOrder=desc&" +
          [taskId ? "taskId=" + taskId : "", limit ? "limit=" + limit : ""]
            .filter(s => s !== "")
            .join("&")
      : null,
    fetcherTyped(LatestJournalResponseSchema),
    { refreshInterval }
  );

  const [latest, setLatest] = useState<EventSourceMessageJournal[]>([]);

  useEffect(() => {
    const logs = data?.logs || [];
    setLatest(
      logs.map(m => {
        return {
          ...m,
          taskType: m.task?.type as TaskType,
          hostId: m.hostId ?? undefined,
          appId: m.appId ?? undefined,
          appName: m.app?.name ?? undefined,
          hostName: m.host?.name ?? undefined
        };
      })
    );
  }, [data]);

  return {
    latest,
    mutate
  };
};
